/**
 * Google Tag Manager Events
 */

export enum GTMEvents {
  WALLET_CONNECTION = "walletConnection",
  SEARCH_STATS = "searchStats",
}
